import script from "./failSuccessListAiList.vue?vue&type=script&lang=jsx&setup=true"
export * from "./failSuccessListAiList.vue?vue&type=script&lang=jsx&setup=true"

import "./failSuccessListAiList.vue?vue&type=style&index=0&id=0fdff8ab&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fdff8ab"]])

export default __exports__